<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnSaveExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnSaveExcel="btnSaveExcel()"
                  >
                  <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">Material Need Date : </span>
                          <v-col cols="2">
                            <DxDateBox
                              :value="startDate"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {startDate = e.value && getStDateFormat(e.value)}"
                            />
                          </v-col>
                          <span class="px-2 d-flex align-center text-h6"> ~ </span>
                          <v-col cols="2">
                            <DxDateBox
                              :value="endDate"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {endDate = e.value && getEdDateFormat(e.value)}"
                            />                 
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Ship No: </span>
                          <v-col cols="2">
                            <v-select
                              v-model="selectShipNo"
                              :items="shipNoList"
                              return-object
                              item-text="shipNo"
                              item-value="shipNo"															
															single-line
															outlined
															dense/>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                
                  <DxDataGrid id="epms91D0" 
                    class="listBox" 
                    :ref="epms91D0Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"  
                    @cellPrepared="cellPrepared"                  
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="block" caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="stage" caption="Stage" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    
                    <DxColumn  data-field="partSpec"  caption="Part Specification" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="porNo" caption="POR No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="cls" caption="Class" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partQty" caption="Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" />                      
                      <DxColumn data-field="partUnitWgt" caption="Weight" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>                                       
                    <DxColumn caption= "Quotation No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="quotNo" caption="PO Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "MND" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="midPsd" caption="Req Iss Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="revPldelydte" caption="Est Dely Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption= "MS" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stMakedte" caption="MF" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "PS" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="stPaintdte" caption="PF" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="initReqwhdte" caption="Insp Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getFirstDate, getCurrentDate, getNumComma } from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { getShipNoList1 } from '@/api/view/hip/common/common.js'
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getEmps91D0, epms91D0Xls } from '@/api/view/hip/91/epms91D0.js'
import dayjs from 'dayjs';

export default {
  name: 'epms91D0',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxDateBox,
    DxColumn,
    DxEditing,    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms91D0Ref: 'epms91D0Ref',
      gridMainList: [],      
      useBtnList: ['btnRetrieve' , 'btnSaveExcel'],
      shipNo: '',
      selectShipNo: '',
			shipNoList: [],       
      startDate: '',
      endDate: '',
      //cell merge
      mergeElements: [],
      mergeStartElements: [],
      makerCd: this.$store.state.user.makerCd
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms91D0Ref)
    },
  },  
  async mounted() {
      await this.init()      
  }, 
  methods: { 

    getStDateFormat(date) {
				this.startDate = getDateFormat(date)        
				return getDateFormat(date)
			},
     
    getEdDateFormat(date) {				
        this.endDate = getDateFormat(date)
				return getDateFormat(date)
			},
  

    init(){				        
        var date = new Date();
        this.startDate = new Date(date.getFullYear(), 0, 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
				this.getShipNoList()
			},

		async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {        

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]
      })
    },

    btnRetrieve(){      
      
      if(this.selectShipNo.shipNo === '' || this.selectShipNo.shipNo === null)
      {  
        this.vToastify(this.$t('Please select Ship No'), 'warn')
        return
      }         
      this.doSearchMain()
      
    },

    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo.shipNo,
        startDate: this.startDate,
        endDate: this.endDate
      }
      console.log(params);
      
      await getEmps91D0(params).then(res => {
          let list = []
          let cnt = 1;        
          res.list.forEach(e => {           
            list.push(
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, block: e.block, stage: e.stage,  
                porNo: e.matlGrpSpec, cls: e.matlGrpSpec, partQty: e.matlGrpSpec, partUnitWgt: e.matlGrpSpec, 
                quotNo:e.quotNo, midPsd: e.mpd, revPldelydte: e.plnDelyDte, stMakedte: e.stMakedte, stPaintdte: e.stPaintdte, initReqwhdte: e.initReqwhdte                
              },
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, block: e.block, stage: e.stage,  
                porNo: e.porNo, cls: e.cls, partQty: e.partQty, partUnitWgt: e.weight, 
                quotNo:e.poDte, midPsd: e.reqIssuedt, revPldelydte: e.plnDelyDte, stMakedte: e.edMakedte, stPaintdte: e.edPaintdte, initReqwhdte: e.initReqwhdte  
              }
            )
        });
        this.gridMainList = list
        
      }).finally(() => {
        this.endLoading()
      })

    },

    btnSaveExcel(){      
      this.openLoading('Excel Saving')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo.shipNo,
        startDate: this.startDate,
        endDate: this.endDate
      }
      epms91D0Xls(params)
      this.endLoading()
    },

    cellPrepared(e) {
      if(e.rowType === 'header') {
        if(e.column.caption.indexOf('Part Specification') > -1) {
          if(e.column.caption === 'Part Specification') {
            e.cellElement.setAttribute('colspan', 4)
          } else {
            e.cellElement.style.display = 'none'
          }
        }
      }      
      else if(e.rowType === 'data') {        
        if(Number(e.rowIndex) % 2 == 0 && (e.column.caption === 'No'||e.column.caption === 'Ship No'||e.column.caption === 'Block'
                                           ||e.column.caption === 'Stage'||e.column.caption === 'Est Dely Date'||e.column.caption === 'Insp Date') ){
            e.cellElement.setAttribute('rowspan', 2)
          }else if(Number(e.rowIndex) % 2 != 0 && (e.column.caption === 'No'||e.column.caption === 'Ship No'||e.column.caption === 'Block'
                ||e.column.caption === 'Stage'||e.column.caption === 'Est Dely Date'||e.column.caption === 'Insp Date') ){
            e.cellElement.style.display = 'none'
          }
          else if(Number(e.rowIndex) % 2 == 0  )
            {
              if (e.column.name === 'porNo'){                               
                  e.cellElement.setAttribute('colspan', 4)
               }  
               else if ((e.column.name === 'cls') || (e.column.name === 'partQty') || (e.column.name === 'partUnitWgt')) {                
                      e.cellElement.style.display = 'none'
             
                }
              
              }  
            }
        } 

    },
    
    


  }

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>